import React from "react";
import PropTypes from "prop-types";
import PricingOptionCategory from "./pricingOptionCategory";
import Modal from "react-modal";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTimesCircle, faEyeSlash, faSearch } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";

export default class PricingOptionCategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.serviceTitleCount = 0;
    this.productTitleCount = 0;
    this.state = {
      showGoal: false,
      sliderValue: 0,
      active: true,
      showEditOverlay: false,
      isEditMode: false,
      modalOpen: false,
      showCreatePrimaryModal: false,
      showCreateSecondaryModal: false,
      showDeleteSecondaryModal: false,
      showModifyModal: false,
      showDeleteModal: false,
      catNameValue: "",
      catTypeValue: "",
      revenueTypeValue: "",
      paymentTypeValue: "",
      calculationValue: "",
      selectedCategory: "",
      selectedTag: "",
      searchValue: ""
    };
  }

  UNSAFE_componentWillUpdate() {
    this.clearTitleCounts();
  }

  clearTitleCounts = () => {
    this.serviceTitleCount = 0;
    this.productTitleCount = 0;
  };

  getAllRevenueCategories() {
    const allCategories = [];
    this.props.data.map((item) => {
      item.revenue_categories.map((item) => {
        allCategories.push(item);
      });
    });
    return allCategories;
  }

  handleNewCatValueChange = (event) => {
    this.setState({ catNameValue: event.target.value });
  };

  handleOptionValueChange = (event, type) => {
    this.setState({
      [type]: event.target.value
    });
  };

  handleOptionValueChangeBoolean = (event, type) => {
    let val = null;
    if (event.target.value === "true") {
      val = true;
    } else {
      val = false;
    }
    this.setState({
      [type]: val
    });
  };

  createNewSecondaryCategory = () => {
    this.props.createSecondaryCategory(
      this.state.selectedCategory.id,
      this.state.catNameValue,
      this.state.catTypeValue,
      this.state.paymentTypeValue,
      this.state.revenueTypeValue,
      this.state.calculationValue
    );
  };

  deleteSecondaryCategory = () => {
    this.props.deleteSecondaryCategory(this.state.selectedCategory.id);
  };

  deletePrimaryCategory = () => {
    this.props.deletePrimaryCategory(this.state.selectedCategory.id);
  };

  getParent() {
    return document.querySelector("body");
  }

  handleCloseModal = () => {
    this.props.clearErrors();
    this.setState({
      modalOpen: false,
      catNameValue: "",
      catTypeValue: "",
      revenueTypeValue: "",
      paymentTypeValue: "",
      selectedCategory: "",
      calculationValue: "",
      showCreatePrimaryModal: false,
      showCreateSecondaryModal: false,
      showModifyModal: false,
      showDeleteModal: false,
      showDeleteSecondaryModal: false,
      showDeletePrimaryModal: false
    });
  };

  handleSearchChange = (event) => {
    this.setState({
      searchValue: event.target.value
    });
  };

  handleSearchCategories = (event) => {
    event.preventDefault();
    this.props.searchCategories(this.state.searchValue);
  };

  createNewCategory = () => {
    this.props.createNewCategory(this.state.catNameValue, this.state.catTypeValue);
  };

  toggleShowEmpty = () => {
    if (this.props.showEmpty) {
      this.props.toggleShowEmpty(false);
    } else {
      this.props.toggleShowEmpty(true);
    }
  };

  toggleShowInactive = () => {
    if (this.props.showInactive) {
      this.props.toggleShowInactive(false);
    } else {
      this.props.toggleShowInactive(true);
    }
  };

  getTags = () => {
    let tags = [
      {
        id: "",
        name: "All"
      }
    ];
    this.props.tagNames?.map((item, index) => {
      let obj = {};
      let obj2 = {};
      obj["id"] = this.props.tagChanges[index];
      obj["name"] = item;
      obj2["id"] = `not_${this.props.tagChanges[index]}`;
      obj2["name"] = `Not ${item}`;
      tags.push(obj, obj2);
    });
    return tags;
  };

  render() {
    library.add(faEdit, faEye, faTimesCircle, faEyeSlash, faSearch);
    return (
      <div>
        <Modal
          // closeTimeoutMS={500}
          ariaHideApp={false}
          parentSelector={this.getParent}
          className="pricingOptionsMappingModal"
          isOpen={this.state.modalOpen}
          // onAfterOpen={this.handleAfterOpenModal}
          onRequestClose={this.handleCloseModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              zIndex: 10000
            },
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 800,
              height: 550,
              bottom: 40,
              backgroundColor: "#262931",
              borderRadius: "10px",
              border: "solid 1px #444",
              padding: "25px",
              outline: "none",
              zIndex: 100000,
              overflow: "none",
              margin: "-275px 0 0 -400px",
              color: "white"
            }
          }}
          contentLabel="Contact Log Modal"
        >
          {!this.state.showCreatePrimaryModal &
          !this.state.showDeleteModal &
          !this.state.showModifyModal &
          !this.state.showCreateSecondaryModal &
          !this.state.showDeleteSecondaryModal &
          !this.state.showDeletePrimaryModal ? (
            <div>
              <h1>Manage Revenue Categories</h1>
              <p>Choose, but choose wisely!</p>
              <h2 style={{ margin: "25px 0 0 0" }}>Primary</h2>
              <div className="select-type" style={{ paddingTop: "5px" }}>
                <button style={styles.submit} onClick={() => this.setState({ showCreatePrimaryModal: true })}>
                  Create
                </button>
                {/* <button style={styles.submit} onClick={() => this.setState({ showModifyModal: true })}>Modify</button> */}
                <button style={styles.submit} onClick={() => this.setState({ showDeletePrimaryModal: true })}>
                  Delete
                </button>
              </div>
              <h2 style={{ margin: "25px 0 0 0" }}>Secondary</h2>
              <div className="select-type" style={{ paddingTop: "5px" }}>
                <button style={styles.submit} onClick={() => this.setState({ showCreateSecondaryModal: true })}>
                  Create
                </button>
                <button style={styles.submit} onClick={() => this.setState({ showDeleteSecondaryModal: true })}>
                  Delete
                </button>
              </div>
            </div>
          ) : null}

          {this.state.showCreatePrimaryModal ? (
            <div>
              <h1>Create Primary Revenue Category</h1>
              <p>Enter name for new category and select category type.</p>
              <input
                type="text"
                style={styles.newCatName}
                placeholder="enter category name"
                value={this.state.catNameValue}
                onChange={this.handleNewCatValueChange}
              />
              <label style={styles.catLabel}>
                Category Type:
                <select value={this.state.catTypeValue} onChange={() => this.handleOptionValueChange(event, "catTypeValue")} style={{ color: "black" }}>
                  <option value="" disabled selected>
                    Select a type
                  </option>
                  <option value="product">Product</option>
                  <option value="service">Service</option>
                </select>
              </label>
              <button
                onClick={() => this.createNewCategory()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  marginTop: "70px",
                  position: "absolute",
                  bottom: "25px",
                  right: "25px",
                  display: this.state.catNameValue === "" || this.state.catTypeValue === "" ? "none" : "block"
                }}
              >
                Submit
              </button>
              {this.props.haveError && <p className="error">{this.props.error}</p>}
            </div>
          ) : null}
          {this.state.showDeletePrimaryModal ? (
            <div>
              <h1>Delete Primary Revenue Category</h1>
              <p>Select category you want to delete.</p>
              <div style={{ width: "300px", marginTop: "20px", float: "left" }}>
                <MultiSelectDropdown
                  options={this.props.data}
                  height={350}
                  singlePicker
                  placeholder="Select Primary Revenue Category"
                  selectAll={false}
                  enableOnly={false}
                  numberDisplayed={1}
                  includeSelectAll={false}
                  defaultSelected={false}
                  haveOnSelectChange
                  onSelectChange={(value) => {
                    this.setState({ selectedCategory: value.length !== 2 ? value[0] : value[1] });
                  }}
                  enableMax
                  maxSelect={1}
                  maxSelected={(data) => console.log(data)}
                />
              </div>
              <button
                onClick={() => this.deletePrimaryCategory()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  marginTop: "70px",
                  position: "absolute",
                  bottom: "25px",
                  right: "25px",
                  display: this.state.selectedCategory === "" ? "none" : "block"
                }}
              >
                Submit
              </button>
              {this.props.haveError && <p className="error">{this.props.error}</p>}
            </div>
          ) : null}
          {this.state.showCreateSecondaryModal ? (
            <div>
              <h1>Create Revenue Category</h1>
              <p>Enter name for new category and select category type.</p>
              <input
                type="text"
                style={styles.newCatName}
                placeholder="enter category name"
                value={this.state.catNameValue}
                onChange={this.handleNewCatValueChange}
              />
              <div style={{ width: "300px", marginTop: "62px", float: "left", marginLeft: "74px" }}>
                <MultiSelectDropdown
                  options={this.props.data}
                  height={350}
                  singlePicker
                  placeholder="Select Primary Revenue Category"
                  selectAll={false}
                  enableOnly={false}
                  numberDisplayed={1}
                  includeSelectAll={false}
                  defaultSelected={false}
                  haveOnSelectChange
                  onSelectChange={(value) => {
                    this.setState({ selectedCategory: value.length !== 2 ? value[0] : value[1] });
                  }}
                  enableMax
                  maxSelect={1}
                  maxSelected={(data) => console.log(data)}
                />
              </div>
              <div style={{ width: "100%", float: "left", paddingTop: "50px" }}>
                <label style={{ ...styles.secondaryCatLabel }}>
                  Category Type:
                  <select
                    value={this.state.catTypeValue}
                    onChange={() => this.handleOptionValueChange(event, "catTypeValue")}
                    style={{ color: "black", display: "block" }}
                  >
                    <option value="" disabled selected>
                      Select a type
                    </option>
                    <option value="product">Product</option>
                    <option value="service">Service</option>
                  </select>
                </label>
                <label style={styles.secondaryCatLabel}>
                  Payment Type:
                  <select
                    value={this.state.paymentTypeValue}
                    onChange={() => this.handleOptionValueChange(event, "paymentTypeValue")}
                    style={{ color: "black", display: "block" }}
                  >
                    <option value="" disabled selected>
                      Select a type
                    </option>
                    <option value="one-time">One Time</option>
                    <option value="prepaid">Pre-paid</option>
                    <option value="recurring">Recurring</option>
                  </select>
                </label>
                <label style={styles.secondaryCatLabel}>
                  Revenue Type:
                  <select
                    value={this.state.revenueTypeValue}
                    onChange={() => this.handleOptionValueChange(event, "revenueTypeValue")}
                    style={{ color: "black", display: "block" }}
                  >
                    <option value="" disabled selected>
                      Select a type
                    </option>
                    <option value="class_pass">Class Pass</option>
                    <option value="revenue">Revenue</option>
                    <option value="expenses">Expenses</option>
                  </select>
                </label>
                <label style={styles.secondaryCatLabel}>
                  Disable Calculation:
                  <select
                    value={this.state.calculationValue}
                    onChange={() => this.handleOptionValueChangeBoolean(event, "calculationValue")}
                    style={{ color: "black", display: "block" }}
                  >
                    <option value="" disabled selected>
                      Select Value
                    </option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </label>
              </div>
              <button
                onClick={() => this.createNewSecondaryCategory()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  marginTop: "70px",
                  position: "absolute",
                  bottom: "25px",
                  right: "25px",
                  display:
                    this.state.catTypeValue === "" ||
                    this.state.catNameValue === "" ||
                    this.state.paymentTypeValue === "" ||
                    this.state.revenueTypeValue === "" ||
                    this.state.calculationValue === "" ||
                    this.state.selectedCategory === ""
                      ? "none"
                      : "block"
                }}
              >
                Submit
              </button>
              {this.props.haveError && <p className="error">{this.props.error}</p>}
            </div>
          ) : null}
          {this.state.showDeleteSecondaryModal ? (
            <div>
              <h1>Delete Secondary Revenue Category</h1>
              <p>Select category you want to delete.</p>
              <div style={{ width: "300px", marginTop: "20px", float: "left" }}>
                <MultiSelectDropdown
                  options={this.getAllRevenueCategories()}
                  height={350}
                  singlePicker
                  placeholder="Select Secondary Revenue Category"
                  selectAll={false}
                  enableOnly={false}
                  numberDisplayed={1}
                  includeSelectAll={false}
                  defaultSelected={false}
                  haveOnSelectChange
                  onSelectChange={(value) => {
                    this.setState({ selectedCategory: value.length !== 2 ? value[0] : value[1] });
                  }}
                  enableMax
                  maxSelect={1}
                  maxSelected={(data) => console.log(data)}
                />
              </div>
              <button
                onClick={() => this.deleteSecondaryCategory()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  marginTop: "70px",
                  position: "absolute",
                  bottom: "25px",
                  right: "25px",
                  display: this.state.selectedCategory === "" ? "none" : "block"
                }}
              >
                Submit
              </button>
              {this.props.haveError && <p className="error">{this.props.error}</p>}
            </div>
          ) : null}
        </Modal>
        <button style={styles.options} onClick={() => this.setState({ modalOpen: true })}>
          <FontAwesomeIcon icon="edit" /> Manage Revenue Categories
        </button>
        <button style={styles.options} onClick={() => this.toggleShowEmpty(true)}>
          <FontAwesomeIcon icon={this.props.showEmpty ? "eye-slash" : "eye"} /> {this.props.showEmpty ? "Hide" : "Show"} Empty
        </button>
        <button style={styles.options} onClick={() => this.toggleShowInactive(true)}>
          <FontAwesomeIcon icon={this.props.showInactive ? "eye-slash" : "eye"} /> {this.props.showInactive ? "Hide" : "Show"} Inactive
        </button>
        <div
          style={{
            position: "absolute",
            right: "197px",
            top: "94px",
            zIndex: 97
          }}
        >
          <FontAwesomeIcon icon="search" />
        </div>
        <form onSubmit={this.handleSearchCategories}>
          <input
            type="text"
            placeholder="search"
            value={this.state.searchValue}
            onChange={this.handleSearchChange}
            style={{
              position: "absolute",
              right: "24px",
              top: "92px",
              paddingLeft: "25px",
              border: "solid 1px #5b606a"
            }}
          />
          <input
            type="submit"
            style={{
              ...styles.submit,
              margin: "22px 0 0 17px",
              float: "left",
              marginTop: "70px",
              position: "absolute",
              right: "226px",
              top: "21px",
              display: this.state.searchValue === "" ? "none" : "block"
            }}
          />
        </form>
        <div className="light" style={{ width: "193px", marginTop: "0px", float: "right" }}>
          <p style={{ position: "absolute", right: "223px", top: "143px", fontSize: "19px", fontWeight: 700 }}>Show Tags:</p>
          <MultiSelectDropdown
            options={this.getTags()}
            height={350}
            singlePicker
            placeholder="Show: All"
            selectAll={false}
            enableOnly={false}
            numberDisplayed={1}
            includeSelectAll={false}
            defaultSelected
            defaultSelectedNumber={1}
            enableDefaultSelected
            haveOnSelectChange
            onSelectChange={(value) => {
              this.setState({ selectedTag: value.length !== 2 ? value[0] : value[1] });
              setTimeout(() => {
                if (this.state.selectedTag !== undefined) {
                  this.props.getCategoriesByTag(this.state.selectedTag.id);
                }
              }, 1);
            }}
            enableMax
            maxSelect={1}
            maxSelected={(data) => console.log(data)}
          />
        </div>
        <div className="pricing-options-wrapper">
          {(this.props.searchedPricingOptions.data.pricing_options.length === 0) & this.props.searchActive ? (
            <div>
              <h1>No results found for: {this.props.searchQuery}</h1>
              <button
                style={{ ...styles.options, position: "absolute", right: "14px", top: "147px", background: "rgb(26, 28, 34)" }}
                onClick={() => this.props.closeSearch()}
              >
                <FontAwesomeIcon icon="times-circle" /> Close
              </button>
            </div>
          ) : null}

          {(this.props.searchedPricingOptions.data.pricing_options.length > 0) & this.props.searchActive ? (
            <PricingOptionCategory
              data={{ id: "Search", name: "SEARCH QUERY" }}
              searchActive
              closeSearch={(value) => this.props.closeSearch(value)}
              searchQuery={this.props.searchQuery}
              allCategories={this.getAllRevenueCategories()}
              optionLoading={this.props.optionLoading}
              pricingOptions={this.props.searchedPricingOptions}
              name="Search Results"
              getPricingOption={(id, rowId) => this.props.getPricingOption(id, rowId)}
              updatePricingOption={(tag, id, cat, active, row) => this.props.updatePricingOption(tag, id, cat, active, row)}
              massUpdateCategory={(changeId, values, row, catId) => this.props.massUpdateCategory(changeId, values, row, catId)}
              massUpdateTags={(tags, nonTags, values, row, catId) => this.props.massUpdateTags(tags, nonTags, values, row, catId)}
              key="search"
              row="search-row"
            />
          ) : null}

          {this.props.tagsLoading ? (
            <LoadingAnimation text="Getting tags, this may take a moment..." customStyle="dark" />
          ) : (
            <span>
              {!this.props.searchActive
                ? this.props.data.map((item) => {
                    const catName = item.name;
                    const catType = item.category_type;
                    return item.revenue_categories.map((item, index) => {
                      if (catType === "service") {
                        this.serviceTitleCount++;
                      }
                      if (catType === "product") {
                        this.productTitleCount++;
                      }
                      return (
                        <span key={`cat-${index}`}>
                          {this.serviceTitleCount === 1 ? <h1>Service</h1> : null}
                          {this.productTitleCount === 1 ? <h1>Product</h1> : null}
                          <PricingOptionCategory
                            data={item}
                            index={index}
                            allCategories={this.getAllRevenueCategories()}
                            optionLoading={this.props.optionLoading}
                            pricingOptions={this.props.pricingOptions}
                            name={catName}
                            getPricingOption={(id, rowId) => this.props.getPricingOption(id, rowId)}
                            updatePricingOption={(tag, id, cat, active, row) => this.props.updatePricingOption(tag, id, cat, active, row)}
                            massUpdateCategory={(changeId, values, row, catId) => this.props.massUpdateCategory(changeId, values, row, catId)}
                            massUpdateTags={(tags, nonTags, values, row, catId) => this.props.massUpdateTags(tags, nonTags, values, row, catId)}
                            key={`cat-${index}`}
                            row={`${catName}-row-${index}`}
                          />
                        </span>
                      );
                    });
                  })
                : null}
            </span>
          )}
        </div>
      </div>
    );
  }
}

PricingOptionCategoryList.propTypes = {
  data: PropTypes.array,
  optionLoading: PropTypes.object,
  pricingOptions: PropTypes.object,
  getPricingOption: PropTypes.func,
  updatePricingOption: PropTypes.func,
  massUpdateCategory: PropTypes.func,
  massUpdateTags: PropTypes.func,
  createNewCategory: PropTypes.func,
  searchCategories: PropTypes.func,
  searchedPricingOptions: PropTypes.object,
  searchActive: PropTypes.bool,
  searchQuery: PropTypes.string,
  createSecondaryCategory: PropTypes.number,
  deleteSecondaryCategory: PropTypes.func,
  deletePrimaryCategory: PropTypes.func,
  closeSearch: PropTypes.func,
  toggleShowEmpty: PropTypes.func,
  showEmpty: PropTypes.bool,
  haveError: PropTypes.bool,
  error: PropTypes.string,
  clearErrors: PropTypes.func,
  showInactive: PropTypes.bool,
  toggleShowInactive: PropTypes.func,
  getCategoriesByTag: PropTypes.func,
  tagsLoading: PropTypes.bool,
  tagNames: PropTypes.array,
  tagChanges: PropTypes.array
};

const styles = {
  submit: {
    padding: "3px 15px",
    background: "rgb(74, 155, 255)",
    border: "none",
    borderRadius: "5px",
    color: "white",
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "14px",
    marginRight: "15px",
    cursor: "pointer"
  },
  options: {
    borderRadius: "5px",
    background: "#8bc34a",
    fontWeight: 800,
    padding: "5px 10px 5px 10px",
    marginRight: "10px",
    color: "white"
  },
  newCatName: {
    width: "300px",
    height: "50px",
    fontSize: "24px",
    marginTop: "50px",
    color: "white",
    float: "left",
    background: "none",
    border: "none",
    borderBottom: "solid 1px"
  },
  catLabel: {
    float: "left",
    marginTop: "58px",
    marginLeft: "51px",
    width: "136px",
    display: "block"
  },
  secondaryCatLabel: {
    float: "left",
    paddingBottom: "10px",
    width: "25%"
  },
  button: {
    padding: "0px 15px",
    height: "25px",
    marginBottom: "10px",
    marginTop: "5px",
    marginLeft: "12px"
  }
};
